import { render, staticRenderFns } from "./inform-pop.vue?vue&type=template&id=7ff4c73e&scoped=true&"
import script from "./inform-pop.vue?vue&type=script&lang=js&"
export * from "./inform-pop.vue?vue&type=script&lang=js&"
import style0 from "./inform-pop.vue?vue&type=style&index=0&id=7ff4c73e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff4c73e",
  null
  
)

export default component.exports